var map = {
	"./icon-activepoint.png": "a437",
	"./icon-bomb.png": "a9f9",
	"./icon-close.png": "6891",
	"./icon-deadpoint-1.png": "b3f6",
	"./icon-deadpoint-10.png": "e338",
	"./icon-deadpoint-11.png": "28e6",
	"./icon-deadpoint-12.png": "b07e",
	"./icon-deadpoint-2.png": "0871",
	"./icon-deadpoint-3.png": "6bc7",
	"./icon-deadpoint-4.png": "0626",
	"./icon-deadpoint-5.png": "d24d",
	"./icon-deadpoint-6.png": "eaf7",
	"./icon-deadpoint-7.png": "9a5e",
	"./icon-deadpoint-8.png": "a8c9",
	"./icon-deadpoint-9.png": "c7af",
	"./icon-deadpoint-control.png": "1827",
	"./icon-deadpoint.png": "d34c",
	"./icon-down.png": "61bb",
	"./icon-fold.png": "82a1",
	"./icon-info.png": "ba96",
	"./icon-landingpoint-1.png": "c820",
	"./icon-landingpoint-10.png": "78c7",
	"./icon-landingpoint-11.png": "527a",
	"./icon-landingpoint-12.png": "afe7",
	"./icon-landingpoint-2.png": "2c35",
	"./icon-landingpoint-3.png": "2d8c",
	"./icon-landingpoint-4.png": "ac38",
	"./icon-landingpoint-5.png": "0b7a",
	"./icon-landingpoint-6.png": "a7ba",
	"./icon-landingpoint-7.png": "caa0",
	"./icon-landingpoint-8.png": "abc2",
	"./icon-landingpoint-9.png": "5a13",
	"./icon-landingpoint-control.png": "3549",
	"./icon-landingpoint.png": "7b84",
	"./icon-movement-control.png": "568b",
	"./icon-movement.png": "0793",
	"./icon-poison.png": "b399",
	"./icon-revive.png": "eab6",
	"./icon-safezone.png": "7e3d",
	"./icon-slotMachine.png": "1a95",
	"./icon-supplies.png": "a5e6",
	"./icon-unfold.png": "95b9",
	"./icon-warning.png": "c27d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e962";